import { ThunkDispatch } from "redux-thunk";

import { connect } from 'react-redux';

import { closeTimeDialog, submitTimeDialog, timeDialogTextChanged, Action } from '../actions';
import { getTimeDialogState, State } from '../reducers';

import TimeDialog from '../components/TimeDialogView';

interface StateProps {
    readonly open: boolean,
    readonly text: string,
}

interface DispatchProps {
    readonly onDialogCancel: () => void,
    readonly onDialogSubmit: () => void,
    readonly onTextChanged: (text: string) => void,
}


const mapStateToProps = (state: State): StateProps => {
    const { open, text } = getTimeDialogState(state);
    return { open, text };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<State, any, Action>): DispatchProps => (
    {
        onDialogCancel: () => {
            dispatch(closeTimeDialog());
        },
        onDialogSubmit: () => {
            dispatch(submitTimeDialog());
        },
        onTextChanged: (text: string) => {
            dispatch(timeDialogTextChanged(text));
        },
    }
);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(TimeDialog);



// WEBPACK FOOTER //
// ./src/containers/TimeDialog.ts